export interface HeaderNavigationState {
  headerProjectName?: string;
  headerProposalName?: string;
}

const PROJECT_HEADER_KEY_PREFIX = 'header-project-name';
const PROPOSAL_HEADER_KEY_PREFIX = 'header-proposal-name';

function readStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage;
}

function normalizeName(value: string | null | undefined): string {
  return String(value ?? '').trim();
}

function projectStorageKey(projectId: string): string {
  return `${PROJECT_HEADER_KEY_PREFIX}:${projectId}`;
}

function proposalStorageKey(projectId: string, ffneId: string): string {
  return `${PROPOSAL_HEADER_KEY_PREFIX}:${projectId}:${ffneId}`;
}

export function persistHeaderProjectName(projectId: string, projectName: string): void {
  const storage = readStorage();
  const nextProjectId = normalizeName(projectId);
  const nextProjectName = normalizeName(projectName);

  if (!storage || !nextProjectId || !nextProjectName) return;
  storage.setItem(projectStorageKey(nextProjectId), nextProjectName);
}

export function getStoredHeaderProjectName(projectId: string): string {
  const storage = readStorage();
  const nextProjectId = normalizeName(projectId);

  if (!storage || !nextProjectId) return '';
  return normalizeName(storage.getItem(projectStorageKey(nextProjectId)));
}

export function persistHeaderProposalName(
  projectId: string,
  ffneId: string,
  proposalName: string,
): void {
  const storage = readStorage();
  const nextProjectId = normalizeName(projectId);
  const nextFfneId = normalizeName(ffneId);
  const nextProposalName = normalizeName(proposalName);

  if (!storage || !nextProjectId || !nextFfneId || !nextProposalName) return;
  storage.setItem(proposalStorageKey(nextProjectId, nextFfneId), nextProposalName);
}

export function getStoredHeaderProposalName(projectId: string, ffneId: string): string {
  const storage = readStorage();
  const nextProjectId = normalizeName(projectId);
  const nextFfneId = normalizeName(ffneId);

  if (!storage || !nextProjectId || !nextFfneId) return '';
  return normalizeName(storage.getItem(proposalStorageKey(nextProjectId, nextFfneId)));
}

export function buildHeaderNavigationState({
  projectId,
  projectName,
  ffneId,
  proposalName,
}: {
  projectId?: string | null;
  projectName?: string | null;
  ffneId?: string | null;
  proposalName?: string | null;
}): HeaderNavigationState {
  const nextProjectId = normalizeName(projectId);
  const nextProjectName = normalizeName(projectName);
  const nextFfneId = normalizeName(ffneId);
  const nextProposalName = normalizeName(proposalName);

  if (nextProjectId && nextProjectName) {
    persistHeaderProjectName(nextProjectId, nextProjectName);
  }

  if (nextProjectId && nextFfneId && nextProposalName) {
    persistHeaderProposalName(nextProjectId, nextFfneId, nextProposalName);
  }

  return {
    ...(nextProjectName ? { headerProjectName: nextProjectName } : {}),
    ...(nextProposalName ? { headerProposalName: nextProposalName } : {}),
  };
}
